export const currency = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
};
